import { render } from "./Encabezado.vue?vue&type=template&id=28df67ae"
import script from "./Encabezado.vue?vue&type=script&lang=js"
export * from "./Encabezado.vue?vue&type=script&lang=js"

import exportComponent from "D:\\gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__